import { Page } from '@thisisdevelopment/heritage-core-library';

export function PageUnavailable() {
  return (
    <Page title="Content Unavailable">
      <div className="flex flex-col items-center justify-center py-20">
        <p className="text-lg text-brand-gray-400">
          This content is temporarily unavailable. Please try again later.
        </p>
      </div>
    </Page>
  );
}
